// Configuration file for environment variables and constants
export const RTK_CACHE_LIFETIME = 3600; 

// Default date format used across the application
export const DEFAULT_DATE_FORMAT = 'DD-MMM-YYYY';

// Environment configuration - defines the current environment (e.g. dev, staging, prod)
export const ENVIRONMENT = process.env.REACT_APP_ENV ?? '';

// Client ID for authentication/identification purposes of cognito
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID ?? '';

// Flag indicating if app is running in local development environment
export const IS_LOCAL = process.env.REACT_APP_IS_LOCAL === "true";

// Validate that required environment variables are set
if (!ENVIRONMENT || !CLIENT_ID ) {
  throw new Error('Missing required environment variables');
}
